const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

/** Keeps only rows for the requested org when the API includes orgId on each member. */
function filterMembersByOrgId(members, orgId) {
  if (!orgId || !Array.isArray(members)) {
    return [];
  }
  return members.filter((member) => {
    if (member?.orgId == null) {
      return true;
    }
    return String(member.orgId) === String(orgId);
  });
}

/**
 * Org-admin scoped search — active members of the caller's org only.
 * @returns {Promise<Array<{ userId: string, email: string, firstName?: string, lastName?: string }>>}
 */
export async function searchOrgMembers({ adminUserId, orgId, search }) {
  const params = new URLSearchParams({
    orgId,
    adminUserId,
    search: search.trim(),
  });
  const response = await fetch(`${apiUrl}/api/org/members/search?${params.toString()}`, {
    method: 'GET',
    headers: {
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
  });
  if (response.status === 403 || response.status === 401) {
    return [];
  }
  if (!response.ok) {
    throw new Error(`Org member search failed: ${response.status}`);
  }
  const data = await response.json();
  return filterMembersByOrgId(Array.isArray(data) ? data : [], orgId);
}
